import { DateRange } from '@angular/material/datepicker';
import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerRange } from '../standalones/components/date-range-picker/date-range-picker.component';

export enum DatepickerRangeName {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  PAST_7_DAYS = 'Past 7 days',
  PAST_14_DAYS = 'Past 14 days',
  PAST_30_DAYS = 'Past 30 days',
  PAST_90_DAYS = 'Past 90 days',
  CUSTOM = 'Custom',
}

@Injectable({
  providedIn: 'root',
})
export class DateRangePickerConstantsService {
  readonly DEFAULT_DATEPICKER_RANGES = new Map<string, DatepickerRange>([
    [
      DatepickerRangeName.TODAY,
      {
        name: DatepickerRangeName.TODAY,
        range: new DateRange<Date>(new Date(), new Date()),
        localizedLabel: this.translate.instant('Today'),
      },
    ],
    [
      DatepickerRangeName.YESTERDAY,
      {
        name: DatepickerRangeName.YESTERDAY,
        range: new DateRange<Date>(
          moment().subtract(1, 'd').toDate(),
          moment().subtract(1, 'd').toDate(),
        ),
        localizedLabel: this.translate.instant('Yesterday'),
      },
    ],
    [
      DatepickerRangeName.PAST_7_DAYS,
      {
        name: DatepickerRangeName.PAST_7_DAYS,
        range: new DateRange<Date>(
          moment()
            .subtract(7 - 1, 'd')
            .toDate(),
          new Date(),
        ),
        localizedLabel: this.translate.instant('Past 7 days'),
      },
    ],
    [
      DatepickerRangeName.PAST_14_DAYS,
      {
        name: DatepickerRangeName.PAST_14_DAYS,
        range: new DateRange<Date>(
          moment()
            .subtract(14 - 1, 'd')
            .toDate(),
          new Date(),
        ),
        localizedLabel: this.translate.instant('Past 14 days'),
      },
    ],
    [
      DatepickerRangeName.PAST_30_DAYS,
      {
        name: DatepickerRangeName.PAST_30_DAYS,
        range: new DateRange<Date>(
          moment()
            .subtract(30 - 1, 'd')
            .toDate(),
          new Date(),
        ),
        localizedLabel: this.translate.instant('Past 30 days'),
      },
    ],
    [
      DatepickerRangeName.PAST_90_DAYS,
      {
        name: DatepickerRangeName.PAST_90_DAYS,
        range: new DateRange<Date>(
          moment()
            .subtract(90 - 1, 'd')
            .toDate(),
          new Date(),
        ),
        localizedLabel: this.translate.instant('Past 90 days'),
      },
    ],
    [
      DatepickerRangeName.CUSTOM,
      {
        name: DatepickerRangeName.CUSTOM,
        range: new DateRange<Date>(null, null),
        localizedLabel: this.translate.instant('Custom'),
      },
    ],
  ]);

  readonly DEFAULT_INITIAL_DATEPICKER_RANGE = this.DEFAULT_DATEPICKER_RANGES.get(
    DatepickerRangeName.PAST_30_DAYS,
  );

  constructor(private translate: TranslateService) {}
}
